import './msgBox.scss';
import helpIcon from '../../images/help.svg';
import lIcon from '../../images/logo.svg';
import axois from 'axios';


const MsgBox = (props) => {

    const handleDelete =async()=>{
        try {
            const response = await axois.delete('http://localhost:2500/testimonials',{data:{id:props.id}});
            if(response){
                console.log(response.status,response.data.token);
                props.setOpen(false);
                window.location.reload();
            }
        } catch (error) {
            console.log(error.message);
        }
    }
    return (
        <div className='msgBox'>
            <div className="modal">
                <div className="bar">
                    <img src={lIcon}  alt="" />
                    <div className="title">Confirmation Message</div>
                    <span className="close" onClick={() => props.setOpen(false)}>X</span>
                </div>

                <div className="msg">
                    <img src={helpIcon} alt="" />
                    <p>Are you sure, you want delete the testimony ('{props.id}')?</p>
                </div>
                <div className="controller">
                    <button onClick={handleDelete}>Yes</button>
                    <button onClick={() => props.setOpen(false)}>No</button>
                </div>

            </div>

        </div>
    )
}

export default MsgBox